import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import { useStored } from 'providers/SelectorProvider.provider';
import { useTheme } from 'providers/Theme.provider';
import { selectActivityNewItems } from 'selectors/activity.selectors';

import CN from './ActivityFeedButton.module.scss';

const generateLink = (history) => {
  // TODO: find better way to do this, with the sidebar style using Redux state, not in URL

  const { pathname } = history.location;
  const segments = pathname.split('/');
  const dayWeekSegment = segments[3];

  if (dayWeekSegment === 'day') {
    return `${segments.slice(0, 5).join('/')}/feed`;
  }

  if (dayWeekSegment === 'week') {
    return `${segments.slice(0, 6).join('/')}/feed`;
  }

  return `${pathname}/feed`;
};

const ActivityFeedButton = ({ history }) => {
  const { isDarkMode } = useTheme();
  const link = generateLink(history);
  const count = useStored(selectActivityNewItems);

  return (
    <NavLink
      data-bem="ActivityFeedButton"
      data-count={count}
      to={link}
      activeClassName="active"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      {count > 0 && <div data-bem="ActivityFeedButton__dot" className={CN.notifications} />}

      <Icon variant="bell" selected width="xl" />
    </NavLink>
  );
};

const ActivityFeedButtonHoc = withRouter(ActivityFeedButton);

export default ActivityFeedButtonHoc;
